import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {I18n} from 'react-redux-i18n';

import config from '../../../../../config';

import {recordGAEvent} from '../../../../utils/analytics';
import {getBdrUrl} from '../../../../utils/path';
import {toggleModal} from '../../../../actions/modals';

import AccessBdrErrorModal from '../../../AccessBdrErrorModal';
import {pathResolver} from '../../../../utils/basePathHelper';

const icon = <img
  alt="icon bdr"
  src={pathResolver('resources/img/icon_bdr_2.png')}
  style={{width: '100%'}}
/>;

function gaEventAccess() {
  recordGAEvent('BdR', 'Accessed Bdr from sidebar menu');
}

function openErrorModal(dispatch) {
  recordGAEvent('BdR', 'Opened Bdr error modal from BdR modal');
  dispatch(toggleModal('accessBdrErrorModal', true));
}

function AccessBdrButton() {
  const dispatch = useDispatch();
  const [organisation = null, bdrServiceAuthorized, userExistsInArtio] = useSelector(state => {
    const orga = state.organisation || null;
    const bdr = state.subscriptions?.[orga?.organisationId]?.bdrServiceAuthorized;
    const existsInArtio = state?.user?.userExistsInArtio;
    return [orga, bdr, existsInArtio];
  });
  const url = React.useMemo(() => getBdrUrl(organisation?.organisationId), [organisation?.organisationId]);

  if (
    !config?.featureFlags?.showAccessBdrButton ||
    !organisation
  ) {
    return null;
  }

  const displayErrorMessage = !userExistsInArtio || !bdrServiceAuthorized;

  const computeErrorKey = () => (!userExistsInArtio && bdrServiceAuthorized ? 'errorNoUserAndBdrService' : 'errorNoBdrService');

  if (displayErrorMessage) {
    return (
      <>
        <button
          data-id="button-bdr"
          onClick={() => openErrorModal(dispatch)}
          className="button-square px-1 flex-container"
          title={I18n.t('menu.bdr')}
        >
          {icon}
        </button>
        <AccessBdrErrorModal
          text1Key={`bdr.${computeErrorKey()}.text1`}
          text2Key={`bdr.${computeErrorKey()}.text2`}
          text3Key={`bdr.${computeErrorKey()}.text3`}
        ></AccessBdrErrorModal>
      </>
    );
  }

  // User exists in Artio and bdr service is authorized -> redirect to marketplace
  return (
    <a
      data-id="button-bdr"
      target="_blank"
      onClick={gaEventAccess}
      href={url}
      className="button-square px-1 flex-container"
      rel="noopener noreferrer"
      title={I18n.t('menu.bdr')}
    >
      {icon}
    </a>
  );
}

export default AccessBdrButton;
